<div class="zesty-modal__backdrop animated fadeIn">
	<div class="zesty-modal__wrapper">
		<div class="zesty-modal">
			<div class="zesty-modal__header">
				<h3 class="zesty-modal__title">{{ data?.title }}</h3>
			</div>
			<div class="zesty-modal__content">
				<br />
				<mat-form-field class="w-100">
					<mat-label>Email:</mat-label>
					<input matInput [formControl]="emailInputControl" />
				</mat-form-field>
				<br />
				<mat-checkbox [formControl]="sendEmailControl">Send email</mat-checkbox>

				<div class="link-container" *ngIf="inviteLink">
					<p>{{ inviteLink }}</p>
					<app-clipboard-copy [text]="inviteLink"></app-clipboard-copy>
				</div>
			</div>
			<div class="zesty-modal__actions">
				<button class="zesty-modal__close" (click)="closeEvent()">Close</button>
				<button
					class="zesty-modal__create-btn"
					[disabled]="emailInputControl.invalid || isLoading"
					(click)="sendInvite()"
				>
					Invite
				</button>
			</div>
		</div>
	</div>
</div>
